function Game({ currentQuestions, onClickVariant, step, questions }) {
  const percentage = Math.round((step / questions.length) * 100);

  return (
    <>
      <div className="progress">
        <div
          className="progress__inner"
          style={{ width: `${percentage}%` }}
        ></div>
      </div>
      <h1>{currentQuestions.title}</h1>
      <ul>
        {currentQuestions.variants.map((text, index) => (
          <li onClick={() => onClickVariant(index)} key={index}>
            {text}
          </li>
        ))}
      </ul>
    </>
  );
}

export default Game;
